import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import ApiRequest from '../Common/restservice';
import { companyColors, companyColorsname, individualColors, individualColorsname, ranknames } from '../Common/showtoast';
import ThemeContext from '../themecontext';

function Directsponsor() {
    const [tableData, setTableData] = useState([]);
    const { theme } = useContext(ThemeContext);
    const navigate = useNavigate();
    useEffect(() => {
        GetDirectSponsors();
    }, [])
    const GetDirectSponsors = async () => {
        let jsoninput = {
            memberid: localStorage.getItem("username")
        };
        let res = await ApiRequest("direct_sponsor_report.asp", "POST", jsoninput, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setTableData(res.items);
    }

    return (
        <section className="content">
            <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                    Direct Team List
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-vcenter text-nowrap mb-0 table-bordered border-top" style={{ textAlign: "center" }}>
                                        <thead className=''>
                                            <tr >
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Ac. No</th>
                                                <th>Date</th>
                                                <th>Status</th>
                                                <th>Rank</th>
                                                <th>Direct Referral</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                tableData.length <= 0 ? <tr>
                                                    <td colSpan="7">No Details Found</td>
                                                </tr> :
                                                    tableData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{(index + 1)}</td>
                                                            <td style={{color: item.package === "10000" ? individualColorsname[item.rank] : item.package === "20000" ? companyColorsname[item.rank] : theme === "dark" ? "white" : 'black'}}>{item.fullname}</td>
                                                            <td>{item.memberid}</td>
                                                            <td>{item.joindate}</td>
                                                            <td>{item.status}</td>
                                                            <td style={{color: item.package === "10000" ? individualColorsname[item.rank] : item.package === "20000" ? companyColorsname[item.rank] : theme === "dark" ? "white" :'black'}}>{item.rank}</td>
                                                            <td>{item.number_of_team}</td>

                                                        </tr>
                                                    ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </section>
    )
}

export default Directsponsor
